'use client';

var __jsx = React.createElement;
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import MuscleFormTextInput from '../form-text-input';
import { IconButton } from '../buttons';
import Icons from '../../../icons';
const PasswordInput = _ref => {
  let {
    label,
    value,
    valueIsInvalid,
    onChangeValue,
    fullLength = true,
    required = false,
    disabled = false,
    labelClassName = '',
    dataTestId
  } = _ref;
  const t = useTranslations('Shared.TextInput');
  const {
    0: visibilityIsOff,
    1: setVisibilityIsOff
  } = useState(true);
  const toggleVisibility = () => {
    setVisibilityIsOff(visibilityIsOff => !visibilityIsOff);
  };
  return __jsx(MuscleFormTextInput, {
    dataTestId: dataTestId,
    label: label || t('PASSWORD'),
    value: value,
    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
    valueIsInvalid: valueIsInvalid,
    onChangeValue: onChangeValue,
    secureTextEntry: visibilityIsOff,
    fullLength: fullLength,
    required: required,
    rightDecoration: __jsx(IconButton, {
      icon: visibilityIsOff ? __jsx(Icons.visibilityOn, {
        size: 20
      }) : __jsx(Icons.visibilityOff, {
        size: 20
      }),
      onClickButton: toggleVisibility
    }),
    disabled: disabled,
    labelClassName: labelClassName
  });
};
export default PasswordInput;